import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import { Button, Container, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

/**
 * A view to show when a certain view was not found.
 */
const NotFoundView = () => (
  <Container
    maxWidth="sm"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      textAlign: 'center',
      padding: 2,
    }}
  >
    <SearchOffRoundedIcon color="error" sx={{ fontSize: 100, mb: 2 }} />
    <Typography variant="h3" component="h1" gutterBottom>
      404 - Page Not Found
    </Typography>
    <Typography variant="body1" color="textSecondary" paragraph>
      Oops! The page you&apos;re looking for doesn&apos;t exist or has been
      moved.
    </Typography>
    <Button
      variant="contained"
      color="primary"
      component={NavLink}
      to="/"
      sx={{ mt: 2 }}
    >
      Go Back Home
    </Button>
  </Container>
);

export default NotFoundView;
